import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmTableModule } from '@app/shared/components/basic-components/dbm-table/dbm-table.module';
import { DbmDropdownModule } from '@app/shared/components/basic-components/dbm-dropdown/dbm-dropdown.module';
import { DbmProgressBarModule } from '@app/shared/components/basic-components/dbm-progress-bar/dbm-progress-bar.module';
import { DbmTimePickerModule } from '@app/shared/components/basic-components/dbm-time-picker/dbm-time-picker.module';
import { DbmCircleProgressBarModule } from '@app/shared/components/basic-components/dbm-circle-progress-bar/dbm-circle-progress-bar.module';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        DbmTableModule,
        DbmDropdownModule,
        DbmProgressBarModule,
        DbmTimePickerModule,
        DbmCircleProgressBarModule
    ],
    declarations:[],
    exports: [
        DbmTableModule,
        DbmDropdownModule,
        DbmProgressBarModule,
        DbmTimePickerModule,
        DbmCircleProgressBarModule
    ]
})
export class BasicComponentsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/basic-components.module.ts